//src/Components/TopBar/NotificationsBellButton.tsx
import { useNotificationsCounter } from 'app/features/notifications/NotificationsCounterProvider';
import { BellIcon } from 'assets/icons';
import { Link } from 'react-router-dom';
import { useAuth } from 'utils/AuthProvider';

export default function NotificationsBellButton() {
  const { dashboard } = useAuth();

  const counter = useNotificationsCounter()?.unread_notifications_count;
  return (
    <div className="tooltip-wrapper">
      <Link to={`${dashboard}/notifications`}>
        <div className="relative cursor-pointer w-8 h-8 shadow mr-2 rounded-full flex justify-center items-center button-wrapper">
          <BellIcon className="w-5 h-5 text-gray-700" />
          {!!counter && (
            <div className="absolute bg-green w-2 h-2 rounded-full right-2.5 top-3 border  border-white"></div>
          )}
        </div>
        <span className="tooltip-text">Notifications</span>
      </Link>
    </div>
  );
}
